import type { AxiosError } from 'axios';
import axios from 'axios';
import { setClient } from '~/core/api/controllers/http-common';

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();

  const client = axios.create({
    baseURL: runtimeConfig.public.apiUrl,
    headers: { 'Content-Type': 'application/json' },
  });

  client.interceptors.request.use(
    (request) => {
      request.params = {
        ...request.params,
        partner_id: runtimeConfig.public.apiPid,
      };

      return request;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );

  setClient(client);
});
